import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileAlt } from "@fortawesome/free-solid-svg-icons";

function ExperimentCard(props: any) {
  return (
    <div className="flex flex-col justify-center items-center py-3 gap-3 rounded-xl border-[1px] border-gray-200 shadow-md">
      <a
        className="w-[70px] hover:scale-[1.1] transition-transform ease-in-out duration-150"
        href={props.link}
      >
        <FontAwesomeIcon
          icon={faFileAlt}
          style={{ width: "100%", height: "100%", color: "#656565" }}
        />
      </a>
      <div className="flex-auto text-center  w-full font-medium px-5 truncate">
        {props.title}
      </div>
    </div>
  );
}

export default ExperimentCard;
